import React, { useState } from "react";
import { Link } from "react-router-dom";

const KilDashboardProductList = () => {
  const [activeTab, setActiveTab] = useState("all");

  const tabs = [
    { id: "all", label: "Tous le Statuts" },
    { id: "published", label: "Publié" },
    { id: "outOfStock", label: "En rupture de stock" },
    { id: "unpublished", label: "Non publié" }
  ];

  const kpiCards = [
    {
      title: "Total des produits",
      value: "1,258",
      change: "+125",
      changeText: "Aujourd'hui",
      percentage: "10%",
      isPositive: true,
      icon: "📦",
      iconColor: "text-purple-600",
      chartColor: "bg-purple-500"
    },
    {
      title: "Publié",
      value: "1,234",
      change: "+123",
      changeText: "Aujourd'hui",
      percentage: "10%",
      isPositive: false,
      icon: "🛍️",
      iconColor: "text-green-600",
      chartColor: "bg-green-500"
    },
    {
      title: "En rupture de stock",
      value: "124",
      change: "+0",
      changeText: "Aujourd'hui",
      percentage: "0%",
      isPositive: false,
      icon: "💤",
      iconColor: "text-red-600",
      chartColor: "bg-red-500"
    }
  ];

  // Simple chart data for the mini charts
  const chartData = [
    [30, 45, 35, 50, 40, 60, 45, 55, 40, 50, 45, 55], // Purple chart
    [40, 35, 50, 45, 55, 40, 50, 45, 55, 40, 50, 45], // Green chart
    [20, 25, 20, 30, 25, 35, 30, 25, 20, 25, 30, 25]  // Red chart
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex justify-between items-start mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Commandes
            <div className="w-16 h-0.5 bg-orange-500 mt-2"></div>
          </h1>
          <div className="text-sm text-gray-600">
            <Link to="/dashboard" className="text-orange-500 hover:text-orange-600">
              Tableau de bord
            </Link>
            <span className="mx-2">{'>'}</span>
            <span>List de produit</span>
          </div>
        </div>
        
        {/* Add Product Button */}
        <Link to="/dashboard/products/add" className="flex items-center gap-2 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Ajouter un produit
        </Link>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {kpiCards.map((card, index) => (
          <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center gap-3">
                <span className={`text-2xl ${card.iconColor}`}>{card.icon}</span>
                <h3 className="text-lg font-semibold text-gray-900">{card.title}</h3>
              </div>
            </div>
            <div className="mb-4">
              <span className="text-3xl font-bold text-gray-900">{card.value}</span>
            </div>
            <div className={`flex items-center gap-1 text-sm mb-4 ${
              card.isPositive ? 'text-green-600' : 'text-red-600'
            }`}>
              <span>{card.percentage}</span>
              <span>{card.isPositive ? '↑' : '↓'}</span>
              <span>{card.change} {card.changeText}</span>
            </div>
            
            {/* Mini Chart */}
            <div className="h-12 flex items-end gap-1">
              {chartData[index].map((height, chartIndex) => (
                <div
                  key={chartIndex}
                  className={`${card.chartColor} rounded-sm`}
                  style={{
                    width: '4px',
                    height: `${height}%`,
                    opacity: 0.7
                  }}
                ></div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Tab Navigation */}
      <div className="flex border-b border-gray-200 mb-6">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`px-6 py-3 text-sm font-medium border-b-2 transition-colors ${
              activeTab === tab.id
                ? 'text-orange-500 border-orange-500'
                : 'text-gray-500 border-transparent hover:text-gray-700 hover:border-gray-300'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Search and Filter Bar */}
      <div className="flex items-center gap-4 mb-6">
        {/* Search Bar */}
        <div className="relative flex-1 max-w-md">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Recherche..."
            className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
          />
        </div>

        {/* Filter Button */}
        <button className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
          <span className="text-gray-700">Filtre</span>
        </button>

        {/* Display Options */}
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          <span className="text-gray-700">Affichage</span>
          <select className="px-3 py-2 border border-gray-300 rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>

      {/* Products Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-6 py-4 text-left">
                  <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                </th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">PRODUIT</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">CATEGORIE</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">PRIX</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">STOCK</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">DATE D'AJOUT</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">STATUT</th>
                <th className="px-6 py-4 text-left text-sm font-medium text-gray-900">ACTION</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {/* Product 1 */}
              <tr className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <img src="/images/ecouteur.png" alt="Earphone G1" className="w-10 h-10 rounded-lg object-cover" />
                    <div>
                      <p className="text-sm font-medium text-gray-900">Earphone G1</p>
                      <p className="text-xs text-gray-500">SKU: JL293819113</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">Audio</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">55.000 FCFA</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">134</span>
                </td>
                <td className="px-6 py-4">
                  <div>
                    <p className="text-sm text-gray-900">14 Jan 2024</p>
                    <p className="text-sm text-gray-500">10:00</p>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                    Publié
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center space-x-4">
                    <button className="text-gray-400 hover:text-blue-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-green-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-red-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>

              {/* Product 2 */}
              <tr className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <img src="/images/ecouteur.png" alt="TWS Earphone M1" className="w-10 h-10 rounded-lg object-cover" />
                    <div>
                      <p className="text-sm font-medium text-gray-900">TWS Earphone M1</p>
                      <p className="text-xs text-gray-500">SKU: JL293819113</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">Audio</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">55.000 FCFA</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">29</span>
                </td>
                <td className="px-6 py-4">
                  <div>
                    <p className="text-sm text-gray-900">14 Jan 2024</p>
                    <p className="text-sm text-gray-500">10:00</p>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-green-100 text-green-800">
                    Publié
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center space-x-4">
                    <button className="text-gray-400 hover:text-blue-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-green-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-red-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>

              {/* Product 3 */}
              <tr className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <img src="/images/app.png" alt="Souris sans fil Logic G1 Pro" className="w-10 h-10 rounded-lg object-cover" />
                    <div>
                      <p className="text-sm font-medium text-gray-900">Souris sans fil Logic G1 Pro</p>
                      <p className="text-xs text-gray-500">SKU: JL293819113</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">Mouse</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">55.000 FCFA</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">240</span>
                </td>
                <td className="px-6 py-4">
                  <div>
                    <p className="text-sm text-gray-900">14 Jan 2024</p>
                    <p className="text-sm text-gray-500">10:00</p>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-800">
                    Non publié
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center space-x-4">
                    <button className="text-gray-400 hover:text-blue-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-green-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-red-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>

              {/* Product 4 */}
              <tr className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <img src="/images/app.png" alt="Berry Samrtwatch" className="w-10 h-10 rounded-lg object-cover" />
                    <div>
                      <p className="text-sm font-medium text-gray-900">Berry Samrtwatch</p>
                      <p className="text-xs text-gray-500">SKU: JL293819113</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">Watch</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">55.000 FCFA</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">0</span>
                </td>
                <td className="px-6 py-4">
                  <div>
                    <p className="text-sm text-gray-900">14 Jan 2024</p>
                    <p className="text-sm text-gray-500">10:00</p>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-red-100 text-red-800">
                    Rupture de stock
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center space-x-4">
                    <button className="text-gray-400 hover:text-blue-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-green-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-red-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>

              {/* Product 5 */}
              <tr className="hover:bg-gray-50">
                <td className="px-6 py-4">
                  <input type="checkbox" className="rounded border-gray-300 text-orange-500 focus:ring-orange-500" />
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <img src="/images/app.png" alt="Souris sans fil Logic G1 Pro" className="w-10 h-10 rounded-lg object-cover" />
                    <div>
                      <p className="text-sm font-medium text-gray-900">Souris sans fil Logic G1 Pro</p>
                      <p className="text-xs text-gray-500">SKU: JL293819113</p>
                    </div>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">Mouse</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">55.000 FCFA</span>
                </td>
                <td className="px-6 py-4">
                  <span className="text-sm text-gray-900">56</span>
                </td>
                <td className="px-6 py-4">
                  <div>
                    <p className="text-sm text-gray-900">14 Jan 2024</p>
                    <p className="text-sm text-gray-500">10:00</p>
                  </div>
                </td>
                <td className="px-6 py-4">
                  <span className="inline-flex px-2 py-1 text-xs font-medium rounded-full bg-gray-100 text-gray-800">
                    Non publié
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="flex items-center space-x-4">
                    <button className="text-gray-400 hover:text-blue-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-green-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button className="text-gray-400 hover:text-red-600">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="bg-white px-6 py-4 border-t border-gray-200 flex items-center justify-between">
          <div className="text-sm text-gray-700">
            Affichage 1-5 sur 5
          </div>
          <div className="flex items-center space-x-2">
            <button className="px-3 py-1 text-gray-500 hover:text-gray-700">◀</button>
            <button className="px-3 py-1 text-white bg-orange-500 rounded-lg">1</button>
            <button className="px-3 py-1 text-gray-500 hover:text-gray-700">▶</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default KilDashboardProductList;
